import axios from '@/http/index';

const base = '';
// 获得统称班次和班次汇总数据
export const getTechnicianClassList = (params) => axios.get(`${base}/erp/technicianClass/getTechnicianClassList`, params).then((res) => res.data);
// 新增或修改班次
export const postSaveOrUpdateClass = (params) => axios.post(`${base}/erp/technicianClass/saveOrUpdateClass`, params).then((res) => res.data);
// 新增或修改统称班次信息
export const postTechnicianClass = (params) => axios.post(`${base}/erp/technicianClass/saveOrUpdateTechnicianClass`, params).then((res) => res.data);
// 获取班次列表信息
export const getClassList = (params) => axios.get(`${base}/erp/technicianClass/getClassList`, params).then((res) => res.data);
